import type { CalibrationView } from '@/types/calibration';

/** The two views the manager card switches between with its own tab strip; the third view
 * (`employees`) is its own tile. */
export type ManagerPivot = Extract<CalibrationView, 'ratingLevel' | 'differentiation'>;

export const MANAGER_PIVOTS: ManagerPivot[] = ['ratingLevel', 'differentiation'];

/** Pivot the report opens on, and the one a return from the employee view lands back on. */
export const DEFAULT_MANAGER_PIVOT: ManagerPivot = 'ratingLevel';

export const isManagerView = (view: CalibrationView): view is ManagerPivot =>
    (MANAGER_PIVOTS as CalibrationView[]).includes(view);

export const isCalibrationView = (value: string | null): value is CalibrationView =>
    value === 'ratingLevel' || value === 'differentiation' || value === 'employees';
